import routerOptions0 from "/opt/vims-fe-live/app/router.options.js";
import routerOptions1 from "/opt/vims-fe-live/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}